// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Ht4z","vLegacy":"SelectSecondary_vLegacy__1cAlV","error":"SelectSecondary_error__2oFBK","disabled":"SelectSecondary_disabled__3Sth8"};